import BoxingTimer from './BoxingTimer';

function App() {
  return <BoxingTimer />;
}

export default App;
